import {SyncEventType} from '../../enums/syncEventType';
import {Issue} from '../../issue';
import {RealtimeEvent} from './realtimeEvent';

export class EventIssuecardUpdated implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_UPDATED;
  public issueId: number;
  public updatedIssue: Issue;
  public avatar: string;

  constructor(issueId: number, updatedIssue: Issue, avatar: string) {
    this.issueId = issueId;
    this.updatedIssue = updatedIssue;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'updatedIssue': this.updatedIssue,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardUpdated {
    return new EventIssuecardUpdated(
      payload['issueId'],
      payload['updatedIssue'], payload['avatar']
    );
  }

}

